class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.summary = this.mainDetailsToggle.querySelector('summary');
    this.content = this.summary.nextElementSibling;

    // Add event listeners
    this.mainDetailsToggle.addEventListener('mouseenter', this.open.bind(this));
    this.mainDetailsToggle.addEventListener('mouseleave', this.close.bind(this));
    this.summary.addEventListener('click', this.redirectToUrl.bind(this));
  }

  open() {
    this.mainDetailsToggle.setAttribute('open', '');
    this.summary.setAttribute('aria-expanded', true);

    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.play());
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.summary.setAttribute('aria-expanded', false);

    if (!this.animations) this.animations = this.content.getAnimations();
    this.animations.forEach((animation) => animation.cancel());
  }

  redirectToUrl(event) {
    event.preventDefault(); // Prevent default `summary` toggle behavior

    const url = this.summary.getAttribute('data-url');
    if (url) {
      window.location.href = url; // Redirect to the `data-url`
    }
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = document.querySelector('.header-wrapper');
  }

  open() {
    super.open();
    if (!this.header) return;
    this.header.preventHide = true;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') === '') {
      document.documentElement.style.setProperty(
        '--header-bottom-position-desktop',
        `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
      );
    }
  }

  close() {
    super.close();
    if (!this.header) return;
    this.header.preventHide = false;
  }
}

customElements.define('header-menu', HeaderMenu);
